import styled from 'styled-components'

export const Container = styled.div`
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  > .top {
  }
  > .table {
    margin-top: 20px;
    height: calc(100% - 80px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    > .card {
      margin-right: 12px;
      margin-bottom: 12px;
    }
  }
  > .pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
    border-top: 1px solid #eff;
  }
`

export const ModalFormContainer = styled.div``
